export default from './Tabs';



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentLoanOfficers/components/Tabs/index.js